module.exports = __webpack_public_path__ + "static/1-02397aa3d5b1a97a4372c6f3105a48e7.jpg";